import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FG031 {
  fg031_01: string;        // 公司代號 (FK)
  fg031_02: string;        // 交運單號 (FK)
  fg031_03: string;        // 繳款單號
  fg031_11: number;        // 繳款金額
  fg031_12: string | null; // 繳款日期
  fg031_91: string;        // 建立人員
  fg031_92: string | null; // 建立/修改日期
  fg031_93: string;        // 修改人員
}

export interface FG03 {
  fg03_01: string;          // 公司代號 (PK1)
  fg03_02: string;          // 交運單號 (PK2)
  fg03_11: number;          // 應收金額
  fg03_12: number;          // 繳款金額
  fg03_13: number;          // 退回金額
  fg03_14: number;          // 折讓金額
  fg03_15: number;          // 客訴金額
  fg03_16: string;          // 幣別代號
  fg03_21: string;          // 單據類別
  fg03_41: number;          // 調整金額
  fg03_42: boolean;         // 可否請款
  fg03_91: string;          // 建立人員
  fg03_92: string | null;   // 建立/修改日期
  fg03_93: string;          // 修改人員
  details: FG031[];         // 繳款明細
}

export interface DetailCreate {
  fg031_03: string;         // 繳款單號
  fg031_11: number;         // 繳款金額
  fg031_12: string | null;  // 繳款日期
}

export interface CreateRequest {
  fg03_01: string;
  fg03_02: string;
  fg03_11: number;
  fg03_12: number;
  fg03_13: number;
  fg03_14: number;
  fg03_15: number;
  fg03_16: string;
  fg03_21: string;
  fg03_41: number;
  fg03_42: boolean;
  details: DetailCreate[];
}

export interface UpdateRequest {
  fg03_11: number;
  fg03_12: number;
  fg03_13: number;
  fg03_14: number;
  fg03_15: number;
  fg03_16: string;
  fg03_21: string;
  fg03_41: number;
  fg03_42: boolean;
  details: DetailCreate[];
}

export interface ListResponse {
  data: FG03[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const receivableDetailApi = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/receivable-detail', { params });
    return res.data;
  },

  async get(companyCode: string, shipNo: string): Promise<FG03> {
    const res = await apiClient.get(`/api/receivable-detail/${encodeURIComponent(companyCode)}/${encodeURIComponent(shipNo)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FG03> {
    const res = await apiClient.post('/api/receivable-detail', data);
    return res.data;
  },

  async update(companyCode: string, shipNo: string, data: UpdateRequest): Promise<FG03> {
    const res = await apiClient.put(`/api/receivable-detail/${encodeURIComponent(companyCode)}/${encodeURIComponent(shipNo)}`, data);
    return res.data;
  },

  async delete(companyCode: string, shipNo: string): Promise<void> {
    await apiClient.delete(`/api/receivable-detail/${encodeURIComponent(companyCode)}/${encodeURIComponent(shipNo)}`);
  },
};
